import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../styles/Sidebar.css";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false); // New state for expanding Settings menu

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".navigation-menu, .navigation-menu__toggle") && isOpen) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isOpen]);

  return (
    <nav className={`navigation-menu ${isOpen ? "navigation-menu--open" : ""}`}>
      <div className="navigation-menu__toggle" onClick={() => setIsOpen(!isOpen)}>
        <span className="navigation-menu__bars"></span>
      </div>

      <ul className="menu-list">
        <li className="menu-list__item"><Link to="/dashboard">Dashboard</Link></li>
        <li className="menu-list__item"><Link to="/email-trigger">Email Trigger</Link></li>
        <li className="menu-list__item"><Link to="/file-path-trigger">File Path Trigger</Link></li>
        <li className="menu-list__item"><Link to="/linked-task-trigger">Linked Task Trigger</Link></li>
        <li className="menu-list__item"><Link to="/whatsapp-trigger">WhatsApp Trigger</Link></li>
        <li className="menu-list__item"><Link to="/trigger-monitoring">Trigger Monitoring</Link></li>
        <li className="menu-list__item"><Link to="/reports">Reports</Link></li>

        {/* Settings - Click to Expand */}
        <li className="menu-list__item" onClick={() => setIsSettingsOpen(!isSettingsOpen)}>
          Settings {isSettingsOpen ? "▼" : "▶"} 
        </li>

        {/* Sub-menu Items (Visible only if Settings is Open) */}
        {isSettingsOpen && (
          <ul className="submenu">
            {/* <li className="submenu__item"><Link to="/logs">Logs</Link></li> */}
            <li className="submenu__item"><Link to="/profile">Profile</Link></li>
            <li className="submenu__item"><Link to="/authorization">Authorization</Link></li>
            <li className="submenu__item"><Link to="/orchestrator">Orchestrator</Link></li>
            
          </ul>
        )}
      </ul>
    </nav>
  );
};

export default Sidebar;
